import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectAiSummaryEntryPoint } from '../../selectors/newbuildingsCompare';
import { AiBannerFloatingExpanded } from '../../components/AiBannerFloatingIcon';
import { useApplicationContext } from '../../utils/applicationContext';
import { SUMMARY_ENABLED_CONFIG_KEY } from '../../constants/summary';

export interface IAiBannerFloatingIconContainerProps {
  visible: boolean;
}

export const AiBannerFloatingIconContainer = ({
  visible,
}: IAiBannerFloatingIconContainerProps): React.JSX.Element | null => {
  const aiSummaryEntryPoint = useSelector(selectAiSummaryEntryPoint);
  const { config } = useApplicationContext();
  const isAiSummaryEnabled = config.get<boolean>(SUMMARY_ENABLED_CONFIG_KEY);

  if (!aiSummaryEntryPoint || !isAiSummaryEnabled) {
    return null;
  }

  return aiSummaryEntryPoint ? <AiBannerFloatingExpanded visible={visible} {...aiSummaryEntryPoint} /> : null;
};
